module.exports = new __parcel__URL__("daily_chest_button.22c1f813.png").toString();